export const getUserData = state => state.motdepasse.userData;
export const getError = state => state.motdepasse.error;
export const getMenu = state => state.menuR.menu;
